import { FilterConfig } from '../../components/Tables/advancedRecord/FilterBar';
import { DropdownDTO } from '../../types/common/DropdownDTO';

export const getRealtimeSubscriptionFilters = (
    roles: DropdownDTO[]
): FilterConfig[] => {

    return [

        {
            name: 'search',
            label: 'Buscar Usuario',
            type: 'text',
            colSpan: 4,
        },

        {
            name: 'role',
            label: 'Rol',
            type: 'select',
            options: roles,
            colSpan: 3,
        },

    ];
};